import { cn } from "utils";

export const CtaVerticalDivider = ({ className }) => (
  <div
    className={cn("h-[18px] w-[2px] shrink-0 bg-gray-400", className)}
    aria-hidden="true"
  />
);

export const ListViewIconButton = ({
  children,
  title,
  onClick,
  disabled,
  className,
  testId,
}) => (
  <button
    type="button"
    data-testid={testId}
    className={cn(
      "rounded p-1.5 text-gray-900 transition-colors hover:bg-gray-100 hover:text-black",
      disabled && "cursor-not-allowed opacity-40 hover:bg-transparent",
      className
    )}
    onClick={(e) => {
      e.stopPropagation();
      if (!disabled) {
        onClick?.(e);
      }
    }}
    disabled={disabled}
    title={title}
  >
    {children}
  </button>
);
